import $ from 'jquery'

// To make large table scroll in the smaller screens;
$(document).ready(function() {
	$('.editor-content table').each(function() {
		$(this).wrap('<div class="table-wrapper"></div>')
	})
})
